import { render, staticRenderFns } from "./ReportSales.vue?vue&type=template&id=4fdb5fee&"
import script from "./ReportSales.vue?vue&type=script&lang=js&"
export * from "./ReportSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdb5fee')) {
      api.createRecord('4fdb5fee', component.options)
    } else {
      api.reload('4fdb5fee', component.options)
    }
    module.hot.accept("./ReportSales.vue?vue&type=template&id=4fdb5fee&", function () {
      api.rerender('4fdb5fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportSales.vue"
export default component.exports